export async function errorRedirection(url, hasReturToLogin) {
  const protocol = window.location.protocol
  const host = window.location.host
  const returnParameter = hasReturToLogin ? '?return=true' : ''
  window.location.href = `${protocol}//${host}${url}${returnParameter}`
}
